import { useEffect } from 'react';
import { Outlet, useParams, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGS, type SupportedLang } from '../i18n';

export default function LanguageLayout() {
  const { lang } = useParams<{ lang?: string }>();
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // If a lang param is present, validate it
    if (lang) {
      if (!SUPPORTED_LANGS.includes(lang as SupportedLang)) {
        // Invalid lang — redirect to English equivalent
        const pathWithoutLang = location.pathname.replace(`/${lang}`, '') || '/';
        navigate(pathWithoutLang + location.search + location.hash, { replace: true });
        return;
      }
      if (i18n.language !== lang) {
        i18n.changeLanguage(lang);
      }
    } else {
      // No lang prefix means English
      if (i18n.language !== 'en') {
        i18n.changeLanguage('en');
      }
    }
    document.documentElement.lang = lang || 'en';
  }, [lang, i18n, navigate, location]);

  return <Outlet />;
}
